module.exports = __webpack_public_path__ + "img/pic_coinstore_happyx3@3x.427c2e88.png";